import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaGift, FaHeart, FaShoppingBag, FaStar, FaSun } from 'react-icons/fa';
import { useGetActiveEventQuery } from '../../slices/promotionApiSlice';

const displayName = (name) => String(name || '')
    .trim()
    .toLocaleLowerCase('es')
    .replace(/(^|\s|-)([a-záéíóúüñ])/gi, (_match, separator, letter) => separator + letter.toLocaleUpperCase('es'));

const SeasonalBanner = ({ userInfo, subtitle }) => {
    const navigate = useNavigate();
    const { data: activeEvent, isLoading } = useGetActiveEventQuery();

    const getIcon = (iconName) => {
        switch (iconName) {
            case 'gift': return <FaGift size={20} />;
            case 'heart': return <FaHeart size={20} />;
            case 'shopping-bag': return <FaShoppingBag size={20} />;
            case 'sun': return <FaSun size={20} />;
            default: return <FaStar size={20} />;
        }
    };

    const event = useMemo(() => {
        if (!activeEvent) return null;

        return {
            id: activeEvent._id,
            title: activeEvent.title.replace('{name}', userInfo ? displayName(userInfo.name) : ''),
            description: activeEvent.description,
            icon: getIcon(activeEvent.icon),
            gradient: activeEvent.gradient,
            buttonText: activeEvent.buttonText,
            keywords: activeEvent.keywords,
            link: `/promotion/${activeEvent._id}`
        };
    }, [activeEvent, userInfo]);

    const handleButtonClick = () => {
        if (event.link === '/') {
            const element = document.getElementById('productos-section');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            navigate(event.link);
        }
    };

    if (isLoading || !event) return null;

    const supportingText = subtitle || event.description;

    return (
        <div
            style={{
                background: event.gradient,
                borderRadius: '16px',
                color: 'white',
                padding: '0.85rem 1rem',
                marginBottom: 0,
                width: '100%',
                boxShadow: '0 8px 20px rgba(181, 67, 15, 0.18)',
                position: 'relative',
                overflow: 'hidden'
            }}
            className="seasonal-banner welcome-badge-wrapper"
        >
            <div
                className="d-flex align-items-center justify-content-between gap-2 gap-md-3 flex-nowrap flex-md-row position-relative"
                style={{ zIndex: 1 }}
            >
                <div className="d-flex align-items-center gap-2 gap-md-3 flex-grow-1" style={{ minWidth: 0 }}>
                    <div
                        className="d-flex align-items-center justify-content-center flex-shrink-0"
                        style={{
                            background: 'rgba(255,255,255,0.18)',
                            borderRadius: '999px',
                            width: '42px',
                            height: '42px',
                            minWidth: '42px',
                            backdropFilter: 'blur(5px)'
                        }}
                    >
                        {event.icon}
                    </div>

                    <div style={{ minWidth: 0 }}>
                        <h2
                            className="fw-bold mb-0"
                            style={{
                                fontSize: '1rem',
                                lineHeight: 1.2
                            }}
                        >
                            {event.title}
                        </h2>
                        <div
                            className="seasonal-banner-subtitle"
                            style={{
                                fontSize: '0.82rem',
                                opacity: 0.95,
                                fontWeight: 400,
                                marginTop: '0.12rem',
                                lineHeight: 1.3,
                                display: '-webkit-box',
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}
                        >
                            {supportingText}
                        </div>
                    </div>
                </div>

                <Button
                    variant="light"
                    size="sm"
                    onClick={handleButtonClick}
                    className="flex-shrink-0"
                    style={{
                        color: '#b5430f',
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '0.45rem 0.9rem',
                        borderRadius: '999px',
                        boxShadow: '0 3px 12px rgba(0,0,0,0.12)',
                        whiteSpace: 'nowrap',
                        fontSize: '0.82rem'
                    }}
                >
                    {event.buttonText}
                </Button>
            </div>

            <div
                style={{
                    position: 'absolute',
                    top: '-70%',
                    right: '-3%',
                    width: '180px',
                    height: '180px',
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '50%',
                    pointerEvents: 'none'
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    bottom: '-95%',
                    right: '18%',
                    width: '110px',
                    height: '110px',
                    background: 'rgba(255,255,255,0.06)',
                    borderRadius: '50%',
                    pointerEvents: 'none'
                }}
            />
        </div>
    );
};

export default SeasonalBanner;
